import { getLocalStorage, storeData } from '../../../utility/LocalStorage';
export function setActiveWorkspace(draft, action) {
    if (action.payload) {
        const { workspace } = action.payload;
        let localData = getLocalStorage('nmr-general-settings');
        draft.workspace.current = workspace;
        localData.currentWorkspace = workspace;
        storeData('nmr-general-settings', JSON.stringify(localData));
    }
}
